import { render, staticRenderFns } from "./fxSet.vue?vue&type=template&id=c4ceaa12&scoped=true&"
import script from "./fxSet.vue?vue&type=script&lang=js&"
export * from "./fxSet.vue?vue&type=script&lang=js&"
import style0 from "./fxSet.vue?vue&type=style&index=0&id=c4ceaa12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ceaa12",
  null
  
)

export default component.exports